export const DATADOG_SERVICE_NAME = 'react-web'
export const DATADOG_KEY = 'pubc18073b8e5ffc47eb031a792d8bd2ada'
export const DATADOG_APPLICATION_ID = 'ec25ee0a-22bd-45e7-9125-521a29299200'
